import {
  createSystem,
  defaultBaseConfig,
  defaultConfig,
  defineConfig,
  mergeConfigs,
} from '@chakra-ui/react';
const systemFont = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Barlow',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
];
const semanticTokens = {
  bg: {
    t0: {
      _light: 'white',
      _dark: '#06080B',
    },
    t1: {
      _light: '#F8F8F9',
      _dark: '#18191D',
    },
    t2: {
      _light: '#F4F5F5',
      _dark: '#1D1F26',
    },
  },
  text: {
    t1: {
      _light: '#06080B',
      _dark: 'white',
    },
    t2: {
      _light: 'rgba(6, 8, 11, 0.60)',
      _dark: 'rgba(255, 255, 255, 0.60)',
    },
    t3: {
      _light: 'rgba(6, 8, 11, 0.40)',
      _dark: 'rgba(255, 255, 255, 0.40)',
    },
    t4: {
      _light: 'rgba(6, 8, 11, 0.05)',
      _dark: 'rgba(255, 255, 255, 0.10)',
    },
    primary: {
      _light: 'rgba(101, 167, 22, 1)',
      _dark: 'rgba(171, 234, 69, 1)',
    },
  },
};
const customConfig = defineConfig({
  strictTokens: false,
  theme: {
    breakpoints: {
      // for download page
      dlg: '768px',
      dxl: '1440px',
      '2dxl': '1920px',
    },
    recipes: {
      button: {
        variants: {
          variant: {
            primary: {
              color: 'text.t2',
              bg: 'bg.t0',
            },
          },
        },
      },
      icon: {
        base: {
          color: 'text.t1',
        },
      },
      input: {
        base: {
          color: 'text.t1',
          borderColor: 'text.t4',
        },
      },
      text: {
        base: {
          color: 'text.t1',
        },
      },
    },
    tokens: {
      fonts: {
        body: { value: ['var(--font-poppins)'].join(',') },
        heading: { value: ['var(--font-poppins)'].join(',') },
      },
      colors: {
        fixed: {
          warning: { value: '#FEA75B' },
          primary: { value: '#ABEA45' },
          green: { value: '#01BC8D' },
          long: { value: '#6FEBB9' },
          longHover: { value: 'rgba(111, 235, 185, 0.1)' },
          short: { value: ' #FFA79B' },
          shortHover: { value: 'rgba(241, 81, 105, 0.1)' },
          white: { value: '#ffffff' },
          'quant-dark-bg': { value: '#0A0B14' },
        },
      },
    },
    semanticTokens: {
      colors: {
        bg: {
          t0: {
            value: {
              _light: semanticTokens.bg.t0._light,
              _dark: semanticTokens.bg.t0._dark,
            },
          },

          t1: {
            value: {
              _light: semanticTokens.bg.t1._light,
              _dark: semanticTokens.bg.t1._dark,
            },
          },
          t2: {
            value: {
              _light: semanticTokens.bg.t2._light,
              _dark: semanticTokens.bg.t2._dark,
            },
          },
        },
        'bg-inverted': {
          t0: {
            value: {
              _light: semanticTokens.bg.t0._dark,
              _dark: semanticTokens.bg.t0._light,
            },
          },
          t1: {
            value: {
              _light: semanticTokens.bg.t1._dark,
              _dark: semanticTokens.bg.t1._light,
            },
          },
          t2: {
            value: {
              _light: semanticTokens.bg.t2._dark,
              _dark: semanticTokens.bg.t2._light,
            },
          },
        },
        text: {
          t1: {
            value: {
              _light: semanticTokens.text.t1._light,
              _dark: semanticTokens.text.t1._dark,
            },
          },
          t2: {
            value: {
              _light: semanticTokens.text.t2._light,
              _dark: semanticTokens.text.t2._dark,
            },
          },
          t3: {
            value: {
              _light: semanticTokens.text.t3._light,
              _dark: semanticTokens.text.t3._dark,
            },
          },
          t4: {
            value: {
              _light: semanticTokens.text.t4._light,
              _dark: semanticTokens.text.t4._dark,
            },
          },
          primary: {
            value: {
              _light: semanticTokens.text.primary._light,
              _dark: semanticTokens.text.primary._dark,
            },
          },
        },
        'text-inverted': {
          t1: {
            value: {
              _light: semanticTokens.text.t1._dark,
              _dark: semanticTokens.text.t1._light,
            },
          },
          t2: {
            value: {
              _light: semanticTokens.text.t2._dark,
              _dark: semanticTokens.text.t2._light,
            },
          },
          t3: {
            value: {
              _light: semanticTokens.text.t3._dark,
              _dark: semanticTokens.text.t3._light,
            },
          },
          t4: {
            value: {
              _light: semanticTokens.text.t4._dark,
              _dark: semanticTokens.text.t4._light,
            },
          },
        },
      },
    },
  },
});
export const system = createSystem(
  defaultBaseConfig,
  mergeConfigs(customConfig, defaultConfig),
);
